// ///////////
// Products //
// ///////////

export const CategoryOrder: {[key: string]: number} = {
  tuxedos: 0,
  suits: 0,
  shirts: 1,
  vests: 2,
  neckwear: 3,
  'neckwear-2': 3,
  shoes: 4,
  cufflinks: 5,
  studs: 6,
  'belts-and-suspenders': 7,
  'pocket-squares': 8,
}

export const RecommendedItemsOrder: string[] = [
  'shoes',
  'shirts',
  'neckwear-2',
  'accessory',
  'cufflinks-studs',
]
